import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ProductReveal } from '../components/ProductReveal';
import { CasesSection } from '../components/CasesSection';
import { IncludedSection } from '../components/IncludedSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { usePricing } from '../hooks/usePricing';
import { initMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  const [timeLeft, setTimeLeft] = useState('00:15:00');
  const pricing = usePricing();
  useEffect(() => {
    // Fire Meta Pixel PageView on load
    initMetaPixel('631216272815399');
  }, []);
  useEffect(() => {
    // Set deadline to 24 hours from now on first load, or use a fixed future date
    // For this demo, we'll just countdown 24 hours from "now" every time the component mounts
    // In a real app, you'd store the deadline in localStorage to persist it
    const deadline = new Date();
    deadline.setMinutes(deadline.getMinutes() + 15);
    const timer = setInterval(() => {
      const now = new Date();
      const difference = deadline.getTime() - now.getTime();
      if (difference <= 0) {
        setTimeLeft('00:00:00');
        clearInterval(timer);
        return;
      }
      const hours = Math.floor(difference / (1000 * 60 * 60) % 24);
      const minutes = Math.floor(difference / 1000 / 60 % 60);
      const seconds = Math.floor(difference / 1000 % 60);
      setTimeLeft(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e5e5e5] font-sans selection:bg-[#cc2200] selection:text-white" data-id="element-183">
      {/* Fixed announcement bar — reserve space to prevent CLS */}
      <div style={{
      height: '36px'
    }} aria-hidden data-id="element-184" />
      <AnnouncementBar timeLeft={timeLeft} data-id="element-185" />

      {/* Grain Overlay */}
      <div className="grain-overlay" data-id="element-186"></div>

      <main className="relative z-10" data-id="element-187">
        <HeroSection timeLeft={timeLeft} price={pricing.loading ? '' : pricing.price} data-id="element-188" />
        <PainSection data-id="element-189" />
        <ProductReveal data-id="element-190" />
        <CasesSection data-id="element-191" />
        <IncludedSection data-id="element-192" />
        <OfferSection timeLeft={timeLeft} price={pricing.loading ? '' : pricing.price} comparePrice={pricing.loading ? '' : pricing.comparePrice} data-id="element-193" />
        <GuaranteeSection data-id="element-194" />
        <FinalCTA data-id="element-195" />
      </main>

      <footer className="bg-[#050505] py-8 text-center text-gray-600 text-sm border-t border-[#222] relative z-10" data-id="element-196">
        <p data-id="element-197">
          © 2024 Investigación Criminal Especial. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-198">
          Este es un producto de ficción para entretenimiento.
        </p>
      </footer>
    </div>;
}